// import { 
//   LayoutDashboard, Users, UserPlus, Store, ShieldCheck, 
//   ClipboardList, Scale, IndianRupee, BarChart3, 
//   UserCog, FileText, ClipboardCheck, Headset, Wallet, 
//   FileBadge, FileQuestion, ReceiptIndianRupee, KeySquare,
//   BadgeCheck,  
//   Briefcase,    
//   FolderKanban, 
//   PackageCheck, 
//   PieChart,     
//   Target,       
//   ChartLine,
//   FileSignature,
//   UserCircle,   
//   FileSpreadsheet, 
//   ClipboardType,  
//   Layers,         
//   UsersRound,
//   MapIcon,
//   IndianRupeeIcon,
//   LucideIdCardLanyard,
//   PowerCircle,
//   Logs,
//   Activity,
//   BookTemplate,
//   User2Icon,
//   KeyRound,
//   Package,     
// } from "lucide-react";

// const navBarData = [
//   // SUPER DASHBOARD
//   { id: "superdashboard", label: "Dashboard", icon: LayoutDashboard, path: "/superdashboard", roles: [1] },
//   // { id: "overview", label: "Lead Overview", icon: LayoutDashboard, path: "/overview", roles: [1] },

//   // MAIN DASHBOARD
//   { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard", roles: [2] },

//       {
//       id: "master",
//       label: "Master",
//       icon: Layers,
//       roles: [1],
//       children: [
//         { id: "categories", label: "Category", path: "/categories", icon: Layers },
//         { id: "brands", label: "Brand", path: "/brands", icon: Layers },
//         { id: "devicemodal", label: "Device Models", path: "/devicemodal", icon: Layers },
//         { id: "products", label: "Products", path: "/products", icon: Layers },
//         { id: "pricetemplate", label: "Price Templates", path: "/pricetemplate", icon: BookTemplate },
//         { id: "badgepackage", label: "Badges & Packages", path: "/badgepackage", icon: BadgeCheck },
//       ]
//     },

//     // {
//     //   id: "partner",
//     //   label: "Partner",
//     //   icon: Layers,
//     //   roles: [1],
//     //   path: "/partners",
//     //   children: [
//     //     { id: "amdcomp", label: "Master Channel Partner (MCP)", path: "/amdcomp", icon: UsersRound, },
//     //     { id: "admagents", label: "Channel Partner (CP)", path: "/admagents", icon: UsersRound, },
//     //     { id: "admretailers", label: "Retailers", path: "/admretailers", icon: Store },
//     //     { id: "admretuser", label: "ARP Users", path: "/admretuser", icon: UserCog },
//     //     { id: "customerlist", label: "Customer List", path: "/customerlist", icon: ClipboardList },
//     //   ]
//     // },

//     { id: "partner", label: "Partners", icon: User2Icon, path: "/partners", roles: [1] },
//     {
//       id: "transactions",
//       label: "Invoices & Payments",
//       icon: IndianRupee,
//       roles: [1],
//       children: [
//         { id: "keys", label: "Payment ID's", path: "/keys", icon: KeySquare, },
//         { id: "paymentlist", label: "Payment List", path: "/paymentlist", icon: IndianRupeeIcon },
//         { id: "retinv", label: "Invoices & Payment", path: "/retinv", icon: ReceiptIndianRupee },
//       ]
//     },
//     {
//       id: "commandearnings",
//       label: "Commissions & Earnings",
//       icon: IndianRupee,
//       roles: [1],
//       children: [
//         { id: "earnings", label: "Earnings", path: "/earnings", icon: ChartLine, },
//         // { id: "admcomsn", label: "Commissions", path: "/admcomsn", icon: ReceiptIndianRupee },
//       ]
//     },

//     {
//       id: "warranty",
//       label: "Warranty Mitra",
//       icon: IndianRupee,
//       path: "/agentdashboard",
//       roles: [4],
//       children: [
//         { id: "agentretailers", label: "ARP & Earnings", icon: Wallet, path: "/agentretailers", roles: [4] },
//         { id: "empdash", label: "Lead", icon: Briefcase, path: "/empdashboard", roles: [4] },
//         { id: "modelpricelist", label: "Pricing List", icon: PowerCircle, path: "/model-price-list", roles: [2,3,4,5] },
//         // { id: "admcomsn", label: "Commissions", path: "/admcomsn", icon: ReceiptIndianRupee },
//       ]
//     },

//     {
//       id: "locker",
//       label: "EMI Locker",
//       icon: IndianRupee,
//       path: "/lockerdashboard",
//       roles: [4],
//       children: [
//         { id: "lockerallretailers", label: "Retailers", path: "/lockerallretailers", icon: Users, },
//         { id: "lockerkeys", label: "Keys", path: "/lockerkeys", icon: KeyRound, },
//         { id: "lockerinventory", label: "Inventory", path: "/lockerinventory", icon: Package, },
//         { id: "lockerorders", label: "Orders", path: "/lockerorders", icon: Package, },
//         { id: "lockerinvoices", label: "Invoices", path: "/lockerinvoices", icon: Package, },
//         // { id: "admcomsn", label: "Commissions", path: "/admcomsn", icon: ReceiptIndianRupee },
//       ]
//     },

//   // ADMIN DASHBOARD
//   // { id: "amdcomp", label: "Master Channel Partner (MCP)", icon: UsersRound, path: "/amdcomp", roles: [2] },
//   { id: "admagents", label: "Channel Partner (CP)", icon: UsersRound, path: "/admagents", roles: [2] },
  
//   { id: "allemployees", label: "Employees", icon: UserPlus, path: "/allemployees", roles:[1] },
//   // { id: "admretailers", label: "Retailers", icon: Store, path: "/admretailers", roles: [1] },
//   // { id: "keys", label: "Payment ID's", icon: KeySquare, path: "/keys", roles: [1] },
//   { id: "admwrnty", label: "Warranties & Claims", icon: ShieldCheck, path: "/admwrnty", roles: [1] },
//   // { id: "admcomsn", label: "Commissions & Payouts", icon: ReceiptIndianRupee, path: "/admcomsn", roles: [1] },
//   // { id: "admtask", label: "Tasks & Work", icon: ClipboardType, path: "/admtask", roles: [1,2] },
//   { id: "admlegal", label: "Legal & Compliance", icon: FileSignature, path: "/admlegal", roles: [1,2] },
//   // { id: "admretuser", label: "ARP Users", icon: UserCog, path: "/admretuser", roles: [1] },
//   // { id: "admanltc", label: "Analytics & Targets", icon: ChartLine, path: "/admanltc", roles: [1,2] },
//   // { id: "devicemodal", label: "Device Model", icon: PackageCheck, path: "/devicemodal", roles: [1] },
//   { id: "assignmap", label: "Assign Map", icon: MapIcon, path: "/assignmap", roles: [1] },
//   // { id: "paymentlist", label: "Payment List", icon: IndianRupeeIcon, path: "/paymentlist", roles: [1] },
  
//   // { id: "payment-details", label: "Payment List", icon: IndianRupeeIcon, path: "/company/payment-details/:paymentId", roles: [1,2] },

//   // EMPLOYEE DASHBOARD
//   { id: "empdash", label: "Dashboard", icon: Briefcase, path: "/empdashboard", roles: [1,2,3] },
//   { id: "teammember", label: "Team Members", icon: Users, path: "/teammember", roles: [1,3] },
//   // { id: "badgepackage", label: "Badges & Packages", icon: BadgeCheck, path: "/badgepackage", roles: [1] },

//   // OPERATION DASHBOARD
//   { id: "oprdash", label: "Dashboard", icon: FolderKanban, path: "/oprdashboard", roles: [3] },
//   { id: "oprret", label: "Users", icon: Store, path: "/oprretail", roles: [3] },
//   // { id: "oprtasks", label: "Tasks", icon: ClipboardCheck, path: "/oprtasks", roles: [3] },
//   { id: "oprreports", label: "Reports", icon: FileSpreadsheet, path: "/oprreports", roles: [3] },

//   // AGENT DASHBOARD
//   // { id: "agentdashboard", label: "Dashboard", icon: Layers, path: "/agentdashboard", roles: [4] },
  
//   // { id: "agtcom", label: "Commission", icon: IndianRupee, path: "/agtcom", roles: [4] },

//   // RETAILER DASHBOARD
//   { id: "retailerdashboard", label: "Home", icon: PieChart, path: "/retailerdashboard", roles: [5] },
//   { id: "retwarnty", label: "Warranty", icon: ShieldCheck, path: "/retwarnty", roles: [5,6] },
//   { id: "customerlist", label: "Customer List", icon: ClipboardList, path: "/customerlist", roles: [5,6] },
//   { id: "earnings", label: "Earnings", icon: ChartLine, path: "/earnings", roles: [2,5,6] },
//   // { id: "admcomsn", label: "Commissions", icon: ReceiptIndianRupee, path: "/admcomsn", roles: [2,4,6] },
//   { id: "retinv", label: "Invoices & Payment", icon: ReceiptIndianRupee, path: "/retinv", roles: [5] },
//   { id: "retproduct", label: "Subscription Products", icon: LucideIdCardLanyard, path: "/retproduct", roles: [5] },
//   { id: "modelpricelist", label: "Pricing List", icon: PowerCircle, path: "/model-price-list", roles: [2,3,5] },
//   // { id: "retledger", label: "Ledger", icon: FileText, path: "/retledger", roles: [5] },
//   { id: "retuser", label: "User & Access", icon: UserCog, path: "/retuser", roles: [5] },
//   { id: "activation-report", label: "Activation Reports", icon: Activity, path: "/activation-report", roles: [2,5] },
//   { id: "retuserdoc", label: "Legal & KYC", icon: FileBadge, path: "/retuserdoc", roles: [5] },
 
//   // USER DASHBOARD
//   { id: "userdashboard", label: "Dashboard", icon: Target, path: "/userdashboard", roles: [6] },
//   // { id: "userwarnty", label: "Warranty", icon: ShieldCheck, path: "/userwarnty", roles: [6] },
//   // { id: "userdoc", label: "Legal & Consents", icon: FileQuestion, path: "/userdoc", roles: [6] },
//   { id: "userprofile", label: "Profile", icon: UserCircle, path: "/userprofile", roles: [6] },

//   // CUSTOMER DASHBOARD
//   { id: "custdashboard", label: "Dashboard", icon: PieChart, path: "/custdashboard", roles: [7] },
//   { id: "custwarnty", label: "My Warranties", icon: ShieldCheck, path: "/custwarnty", roles: [7] },
//   { id: "custclaims", label: "Claims", icon: ClipboardCheck, path: "/custclaims", roles: [7] },
//   { id: "custdoc", label: "Legal & Policy", icon: FileQuestion, path: "/custdoc", roles: [7] },
//   { id: "custspt", label: "Support", icon: Headset, path: "/custspt", roles: [7] },

//   { id: "report-logs", label: "Message Logs", icon: Logs, path: "/report-logs", roles: [1] },

//   // locker 

//   // { id: "locker", label: "Locker", icon: Logs, path: "/locker", roles: [4] },
  
// ];

// export default navBarData;


// *******************************************code without agent change*************************************

import { 
  LayoutDashboard, Users, UserPlus, Store, ShieldCheck, 
  ClipboardList, Scale, IndianRupee, BarChart3, 
  UserCog, FileText, ClipboardCheck, Headset, Wallet, 
  FileBadge, FileQuestion, ReceiptIndianRupee, KeySquare,
  BadgeCheck,  
  Briefcase,    
  FolderKanban, 
  PackageCheck, 
  PieChart,     
  Target,       
  ChartLine,
  FileSignature,
  UserCircle,   
  FileSpreadsheet, 
  ClipboardType,  
  Layers,         
  UsersRound,
  MapIcon,
  IndianRupeeIcon,
  LucideIdCardLanyard,
  PowerCircle,
  Logs,
  Activity,
  BookTemplate,
  User2Icon,     
} from "lucide-react";

const navBarData = [
  // SUPER DASHBOARD
  { id: "superdashboard", label: "Dashboard", icon: LayoutDashboard, path: "/superdashboard", roles: [1] },
  // { id: "overview", label: "Lead Overview", icon: LayoutDashboard, path: "/overview", roles: [1] },

  // MAIN DASHBOARD
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard", roles: [2] },

      {
      id: "master",
      label: "Master",
      icon: Layers,
      roles: [1],
      children: [
        { id: "categories", label: "Category", path: "/categories", icon: Layers },
        { id: "brands", label: "Brand", path: "/brands", icon: Layers },
        { id: "devicemodal", label: "Device Models", path: "/devicemodal", icon: Layers },
        { id: "products", label: "Products", path: "/products", icon: Layers },
        { id: "pricetemplate", label: "Price Templates", path: "/pricetemplate", icon: BookTemplate },
        { id: "badgepackage", label: "Badges & Packages", path: "/badgepackage", icon: BadgeCheck },
      ]
    },

    // {
    //   id: "partner",
    //   label: "Partner",
    //   icon: Layers,
    //   roles: [1],
    //   path: "/partners",
    //   children: [
    //     { id: "amdcomp", label: "Master Channel Partner (MCP)", path: "/amdcomp", icon: UsersRound, },
    //     { id: "admagents", label: "Channel Partner (CP)", path: "/admagents", icon: UsersRound, },
    //     { id: "admretailers", label: "Retailers", path: "/admretailers", icon: Store },
    //     { id: "admretuser", label: "ARP Users", path: "/admretuser", icon: UserCog },
    //     { id: "customerlist", label: "Customer List", path: "/customerlist", icon: ClipboardList },
    //   ]
    // },

    { id: "partner", label: "Partners", icon: User2Icon, path: "/partners", roles: [1] },
    {
      id: "transactions",
      label: "Invoices & Payments",
      icon: IndianRupee,
      roles: [1],
      children: [
        { id: "keys", label: "Payment ID's", path: "/keys", icon: KeySquare, },
        { id: "paymentlist", label: "Payment List", path: "/paymentlist", icon: IndianRupeeIcon },
        { id: "retinv", label: "Invoices & Payment", path: "/retinv", icon: ReceiptIndianRupee },
      ]
    },
    {
      id: "commandearnings",
      label: "Commissions & Earnings",
      icon: IndianRupee,
      roles: [1],
      children: [
        { id: "earnings", label: "Earnings", path: "/earnings", icon: ChartLine, },
        { id: "admcomsn", label: "Commissions", path: "/admcomsn", icon: ReceiptIndianRupee },
      ]
    },

  // ADMIN DASHBOARD
  // { id: "amdcomp", label: "Master Channel Partner (MCP)", icon: UsersRound, path: "/amdcomp", roles: [2] },
  { id: "admagents", label: "Channel Partner (CP)", icon: UsersRound, path: "/admagents", roles: [2] },
  
  { id: "allemployees", label: "Employees", icon: UserPlus, path: "/allemployees", roles:[2] },
  // { id: "admretailers", label: "Retailers", icon: Store, path: "/admretailers", roles: [1] },
  // { id: "keys", label: "Payment ID's", icon: KeySquare, path: "/keys", roles: [1] },
  { id: "admwrnty", label: "Warranties & Claims", icon: ShieldCheck, path: "/admwrnty", roles: [1] },
  // { id: "admcomsn", label: "Commissions & Payouts", icon: ReceiptIndianRupee, path: "/admcomsn", roles: [1] },
  // { id: "admtask", label: "Tasks & Work", icon: ClipboardType, path: "/admtask", roles: [1,2] },
  { id: "admlegal", label: "Legal & Compliance", icon: FileSignature, path: "/admlegal", roles: [1,2] },
  // { id: "admretuser", label: "ARP Users", icon: UserCog, path: "/admretuser", roles: [1] },
  // { id: "admanltc", label: "Analytics & Targets", icon: ChartLine, path: "/admanltc", roles: [1,2] },
  // { id: "devicemodal", label: "Device Model", icon: PackageCheck, path: "/devicemodal", roles: [1] },
  { id: "assignmap", label: "Assign Map", icon: MapIcon, path: "/assignmap", roles: [1] },
  // { id: "paymentlist", label: "Payment List", icon: IndianRupeeIcon, path: "/paymentlist", roles: [1] },
  
  // { id: "payment-details", label: "Payment List", icon: IndianRupeeIcon, path: "/company/payment-details/:paymentId", roles: [1,2] },

  // EMPLOYEE DASHBOARD
  { id: "empdash", label: "Dashboard", icon: Briefcase, path: "/empdashboard", roles: [1,2,3,4] },
  { id: "teammember", label: "Team Members", icon: Users, path: "/teammember", roles: [1,3] },
  // { id: "badgepackage", label: "Badges & Packages", icon: BadgeCheck, path: "/badgepackage", roles: [1] },

  // OPERATION DASHBOARD
  { id: "oprdash", label: "Dashboard", icon: FolderKanban, path: "/oprdashboard", roles: [3] },
  { id: "oprret", label: "Users", icon: Store, path: "/oprretail", roles: [3] },
  { id: "stepsprogress", label: "Step Progress", icon: Store, path: "/stepsprogress", roles: [1,2,3,4] },
  // { id: "oprtasks", label: "Tasks", icon: ClipboardCheck, path: "/oprtasks", roles: [3] },
  { id: "oprreports", label: "Reports", icon: FileSpreadsheet, path: "/oprreports", roles: [3] },

  // AGENT DASHBOARD
  { id: "agentdashboard", label: "Dashboard", icon: Layers, path: "/agentdashboard", roles: [4] },
  { id: "agentretailers", label: "ARP & Earnings", icon: Wallet, path: "/agentretailers", roles: [4] },
  // { id: "agtcom", label: "Commission", icon: IndianRupee, path: "/agtcom", roles: [4] },

  // RETAILER DASHBOARD
  { id: "retailerdashboard", label: "Home", icon: PieChart, path: "/retailerdashboard", roles: [5] },
  { id: "retwarnty", label: "Warranty", icon: ShieldCheck, path: "/retwarnty", roles: [5,6] },
  { id: "customerlist", label: "Customer List", icon: ClipboardList, path: "/customerlist", roles: [5,6] },
  { id: "earnings", label: "Earnings", icon: ChartLine, path: "/earnings", roles: [2,4,5,6] },
  { id: "admcomsn", label: "Commissions", icon: ReceiptIndianRupee, path: "/admcomsn", roles: [2,4,6] },
  { id: "retinv", label: "Invoices & Payment", icon: ReceiptIndianRupee, path: "/retinv", roles: [5] },
  { id: "retproduct", label: "Subscription Products", icon: LucideIdCardLanyard, path: "/retproduct", roles: [5] },
  { id: "modelpricelist", label: "Pricing List", icon: PowerCircle, path: "/model-price-list", roles: [2,3,4,5] },
  // { id: "retledger", label: "Ledger", icon: FileText, path: "/retledger", roles: [5] },
  { id: "retuser", label: "User & Access", icon: UserCog, path: "/retuser", roles: [5] },
  { id: "activation-report", label: "Activation Reports", icon: Activity, path: "/activation-report", roles: [1,3,2,5] },
  { id: "retuserdoc", label: "Legal & KYC", icon: FileBadge, path: "/retuserdoc", roles: [5] },
 
  // USER DASHBOARD
  { id: "userdashboard", label: "Dashboard", icon: Target, path: "/userdashboard", roles: [6] },
  // { id: "userwarnty", label: "Warranty", icon: ShieldCheck, path: "/userwarnty", roles: [6] },
  // { id: "userdoc", label: "Legal & Consents", icon: FileQuestion, path: "/userdoc", roles: [6] },
  { id: "userprofile", label: "Profile", icon: UserCircle, path: "/userprofile", roles: [6] },

  // CUSTOMER DASHBOARD
  { id: "custdashboard", label: "Dashboard", icon: PieChart, path: "/custdashboard", roles: [7] },
  { id: "custwarnty", label: "My Warranties", icon: ShieldCheck, path: "/custwarnty", roles: [7] },
  { id: "custclaims", label: "Claims", icon: ClipboardCheck, path: "/custclaims", roles: [7] },
  { id: "custdoc", label: "Legal & Policy", icon: FileQuestion, path: "/custdoc", roles: [7] },
  { id: "custspt", label: "Support", icon: Headset, path: "/custspt", roles: [7] },

  { id: "report-logs", label: "Message Logs", icon: Logs, path: "/report-logs", roles: [1] },
  
];

export default navBarData;

// **********************************************original code***********************************************

// import { 
//   LayoutDashboard, Users, UserPlus, Store, ShieldCheck, 
//   ClipboardList, Scale, IndianRupee, BarChart3, 
//   UserCog, FileText, ClipboardCheck, Headset, Wallet, 
//   FileBadge, FileQuestion, ReceiptIndianRupee, KeySquare,
//   BadgeCheck,  
//   Briefcase,    
//   FolderKanban, 
//   PackageCheck, 
//   PieChart,     
//   Target,       
//   ChartLine,    
//   FileSignature,
//   UserCircle,   
//   FileSpreadsheet, 
//   ClipboardType,  
//   Layers,         
//   UsersRound,
//   MapIcon,
//   IndianRupeeIcon,
//   LucideIdCardLanyard,
//   PowerCircle,
//   Logs,
//   Activity,     
// } from "lucide-react";

// const navBarData = [
//   // SUPER DASHBOARD
//   { id: "superdashboard", label: "Dashboard", icon: LayoutDashboard, path: "/superdashboard", roles: [1] },
//   // { id: "overview", label: "Lead Overview", icon: LayoutDashboard, path: "/overview", roles: [1] },

//   // MAIN DASHBOARD
//   { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard", roles: [2] },

//   // ADMIN DASHBOARD
//   { id: "admagents", label: "Channel Partner (CP)", icon: UsersRound, path: "/admagents", roles: [1,2] },
//   // { id: "allemployees", label: "Employees", icon: UserPlus, path: "/allemployees", roles:[2] },
//   { id: "admretailers", label: "Retailers", icon: Store, path: "/admretailers", roles: [1] },
//   { id: "keys", label: "Payment ID's", icon: KeySquare, path: "/keys", roles: [1] },
//   { id: "admwrnty", label: "Warranties & Claims", icon: ShieldCheck, path: "/admwrnty", roles: [1] },
//   { id: "admcomsn", label: "Commissions & Payouts", icon: ReceiptIndianRupee, path: "/admcomsn", roles: [1] },
//   // { id: "admtask", label: "Tasks & Work", icon: ClipboardType, path: "/admtask", roles: [1,2] },
//   { id: "admlegal", label: "Legal & Compliance", icon: FileSignature, path: "/admlegal", roles: [1,2] },
//   { id: "admretuser", label: "ARP Users", icon: UserCog, path: "/admretuser", roles: [1] },
//   // { id: "admanltc", label: "Analytics & Targets", icon: ChartLine, path: "/admanltc", roles: [1,2] },
//   { id: "devicemodal", label: "Device Model", icon: PackageCheck, path: "/devicemodal", roles: [1] },
//   { id: "assignmap", label: "Assign Map", icon: MapIcon, path: "/assignmap", roles: [1] },
//   { id: "paymentlist", label: "Payment List", icon: IndianRupeeIcon, path: "/paymentlist", roles: [1] },
  
//   // { id: "payment-details", label: "Payment List", icon: IndianRupeeIcon, path: "/company/payment-details/:paymentId", roles: [1,2] },

//   // EMPLOYEE DASHBOARD
//   { id: "empdash", label: "Dashboard", icon: Briefcase, path: "/empdashboard", roles: [1,2,3,4] },
//   { id: "teammember", label: "Team Members", icon: Users, path: "/teammember", roles: [1,3] },
//   { id: "badgepackage", label: "Badges & Packages", icon: BadgeCheck, path: "/badgepackage", roles: [1] },

//   // OPERATION DASHBOARD
//   { id: "oprdash", label: "Dashboard", icon: FolderKanban, path: "/oprdashboard", roles: [3] },
//   { id: "oprret", label: "Users", icon: Store, path: "/oprretail", roles: [3] },
//   // { id: "oprtasks", label: "Tasks", icon: ClipboardCheck, path: "/oprtasks", roles: [3] },
//   { id: "oprreports", label: "Reports", icon: FileSpreadsheet, path: "/oprreports", roles: [3] },

//   // AGENT DASHBOARD
//   { id: "agentdashboard", label: "Dashboard", icon: Layers, path: "/agentdashboard", roles: [4] },
//   { id: "agentretailers", label: "ARP & Earnings", icon: Wallet, path: "/agentretailers", roles: [4] },
//   { id: "agtcom", label: "Commission", icon: IndianRupee, path: "/agtcom", roles: [4] },

//   // RETAILER DASHBOARD
//   { id: "retailerdashboard", label: "Home", icon: PieChart, path: "/retailerdashboard", roles: [5] },
//   { id: "retwarnty", label: "Warranty", icon: ShieldCheck, path: "/retwarnty", roles: [5,6] },
//   { id: "customerlist", label: "Customer List", icon: ClipboardList, path: "/customerlist", roles: [1,5,6] },
//   { id: "earnings", label: "Earnings", icon: ChartLine, path: "/earnings", roles: [2,5,6] },
//   { id: "retinv", label: "Invoices & Payment", icon: ReceiptIndianRupee, path: "/retinv", roles: [5,1] },
//   { id: "retproduct", label: "Subscription Products", icon: LucideIdCardLanyard, path: "/retproduct", roles: [5] },
//   { id: "modelpricelist", label: "Pricing List", icon: PowerCircle, path: "/model-price-list", roles: [2,3,4,5] },
//   // { id: "retledger", label: "Ledger", icon: FileText, path: "/retledger", roles: [5] },
//   { id: "retuser", label: "User & Access", icon: UserCog, path: "/retuser", roles: [5] },
//   { id: "activation-report", label: "Activation Reports", icon: Activity, path: "/activation-report", roles: [2,5] },
//   { id: "retuserdoc", label: "Legal & KYC", icon: FileBadge, path: "/retuserdoc", roles: [5] },
 
//   // USER DASHBOARD
//   { id: "userdashboard", label: "Dashboard", icon: Target, path: "/userdashboard", roles: [6] },
//   // { id: "userwarnty", label: "Warranty", icon: ShieldCheck, path: "/userwarnty", roles: [6] },
//   // { id: "userdoc", label: "Legal & Consents", icon: FileQuestion, path: "/userdoc", roles: [6] },
//   { id: "userprofile", label: "Profile", icon: UserCircle, path: "/userprofile", roles: [6] },

//   // CUSTOMER DASHBOARD
//   { id: "custdashboard", label: "Dashboard", icon: PieChart, path: "/custdashboard", roles: [7] },
//   { id: "custwarnty", label: "My Warranties", icon: ShieldCheck, path: "/custwarnty", roles: [7] },
//   { id: "custclaims", label: "Claims", icon: ClipboardCheck, path: "/custclaims", roles: [7] },
//   { id: "custdoc", label: "Legal & Policy", icon: FileQuestion, path: "/custdoc", roles: [7] },
//   { id: "custspt", label: "Support", icon: Headset, path: "/custspt", roles: [7] },

//   { id: "report-logs", label: "Message Logs", icon: Logs, path: "/report-logs", roles: [1] },
  
// ];

// export default navBarData;


// import { 
//   LayoutDashboard, Users, UserPlus, Store, ShieldCheck, 
//   ClipboardList, Scale, IndianRupee, BarChart3, 
//   UserCog, FileText, ClipboardCheck, Headset, Wallet, 
//   FileBadge, FileQuestion, ReceiptIndianRupee,
//   KeySquare,
// } from "lucide-react";

// const navBarData = [
//   // SUPER DASHBOARD
//   { id: "superdashboard", label: "Dashboard", icon: LayoutDashboard, path: "/superdashboard", roles: [1] }, // 1 = Admin
  

//   // MAIN DASHBOARD
//   { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard", roles: [2] }, // 2 = Company
//   // { id: "admindashboard", label: "Admin Dashboard", icon: LayoutDashboard, path: "/admindashboard", roles: [2] },

//   // ADMIN DASHBOARD
//   { id: "admagents", label: "Agents & Onboarding", icon: Users, path: "/admagents", roles: [1,2] },
//   { id: "admretailers", label: "Ops · Retailers", icon: Store, path: "/admretailers", roles: [1,2] },
//   { id: "keys", label: "Keys", icon: KeySquare, path: "/keys", roles: [1] }, 
//   { id: "admwrnty", label: "Warranties & Claims", icon: ShieldCheck, path: "/admwrnty", roles: [1,2] },
//   { id: "admcomsn", label: "Commissions & Payouts", icon: IndianRupee, path: "/admcomsn", roles: [1,2] },
//   { id: "admtask", label: "Tasks & Work", icon: ClipboardList, path: "/admtask", roles: [1,2] },
//   { id: "admlegal", label: "Legal & Compliance", icon: Scale, path: "/admlegal", roles: [1,2] },
//   { id: "admretuser", label: "Retailer Users", icon: UserCog, path: "/admretuser", roles: [1,2] },
//   { id: "admanltc", label: "Analytics & Targets", icon: BarChart3, path: "/admanltc", roles: [1,2] },

//   // EMPLOYEE DASHBOARD
//   { id: "empdash", label: "EMP Dashboard", icon: LayoutDashboard, path: "/empdashboard", roles: [1,2,3,4] }, // 3=Employee, 4=Agent
//   { id: "badgepackage", label: "Badges & Packages", icon: LayoutDashboard, path: "/badgepackage", roles: [1] }, // 3=Employee, 4=Agent

//   // OPERATION DASHBOARD
//   { id: "oprdash", label: "OPR Dashboard", icon: LayoutDashboard, path: "/oprdashboard", roles: [3] },
//   { id: "oprret", label: "Retailers", icon: Store, path: "/oprretail", roles: [3] },
//   { id: "oprtasks", label: "Tasks", icon: ClipboardCheck, path: "/oprtasks", roles: [3] },
//   { id: "oprreports", label: "Reports", icon: FileText, path: "/oprreports", roles: [3] },

//   // AGENT DASHBOARD
//   { id: "agentdashboard", label: "Agent Dashboard", icon: LayoutDashboard, path: "/agentdashboard", roles: [4] },
//   { id: "agentretailers", label: "Retailers & Earnings", icon: Wallet, path: "/agentretailers", roles: [4] },
//   { id: "agtcom", label: "Commission", icon: IndianRupee, path: "/agtcom", roles: [4] },

//   // RETAILER DASHBOARD
//   // { id: "retaileronboard", label: "Retailer Onboarding", icon: UserPlus, path: "/onboard", roles: [2,5] },
//   { id: "retailerdashboard", label: "Retailer Dashboard", icon: LayoutDashboard, path: "/retailerdashboard", roles: [5] },
//   { id: "retwarnty", label: "Warranty", icon: ShieldCheck, path: "/retwarnty", roles: [5] },
//   { id: "retinv", label: "Invoices & Payment", icon: ReceiptIndianRupee, path: "/retinv", roles: [5] },
//   { id: "retledger", label: "Ledger", icon: FileText, path: "/retledger", roles: [5] },
//   { id: "retuser", label: "User & Access", icon: UserCog, path: "/retuser", roles: [5] },
//   { id: "retuserdoc", label: "Legal & KYC", icon: FileBadge, path: "/retuserdoc", roles: [5] },

//   // USER DASHBOARD
//   { id: "userdashboard", label: "User Dashboard", icon: LayoutDashboard, path: "/userdashboard", roles: [6] },
//   { id: "userwarnty", label: "Warranty", icon: ShieldCheck, path: "/userwarnty", roles: [6] },
//   { id: "userdoc", label: "Legal & Consents", icon: FileQuestion, path: "/userdoc", roles: [6] },
//   { id: "userprofile", label: "Profile", icon: Users, path: "/userprofile", roles: [6] },

//   // CUSTOMER DASHBOARD
//   { id: "custdashboard", label: "Cust Dashboard", icon: LayoutDashboard, path: "/custdashboard", roles: [5,7] },
//   { id: "custwarnty", label: "My Warranties", icon: ShieldCheck, path: "/custwarnty", roles: [5,7] },
//   { id: "custclaims", label: "Claims", icon: ClipboardList, path: "/custclaims", roles: [5,7] },
//   { id: "custdoc", label: "Legal & Policy", icon: FileQuestion, path: "/custdoc", roles: [5,7] },
//   { id: "custspt", label: "Support", icon: Headset, path: "/custspt", roles: [5,7] },
// ];

// export default navBarData;



// import { 
//   LayoutDashboard, Users, UserPlus, Store, ShieldCheck, 
//   ClipboardList, Scale, IndianRupee, BarChart3, 
//   UserCog, FileText, ClipboardCheck, Headset, Wallet, 
//   FileBadge, FileQuestion, ReceiptIndianRupee,
// } from "lucide-react";

// const navBarData = [
//   // SUPER DASHBOARD
//   { id: "superdashboard", label: "Super Admin Dashboard", icon: LayoutDashboard, path: "/superdashboard", roles: ["admin", "superadmin"] },

//   // MAIN DASHBOARD
//   { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard", roles: ["company"] },

//   // ADMIN DASHBOARD
//   { id: "admagents", label: "Agents & Onboarding", icon: Users, path: "/admagents", roles: ["company","admin"] },
//   { id: "admretailers", label: "Ops · Retailers", icon: Store, path: "/admretailers", roles: ["company", "admin"] },
 
//   { id: "admwrnty", label: "Warranties & Claims", icon: ShieldCheck, path: "/admwrnty", roles: ["company","admin"] },
//   { id: "admcomsn", label: "Commissions & Payouts", icon: IndianRupee, path: "/admcomsn", roles: ["company","admin"] },
//   { id: "admtask", label: "Tasks & Work", icon: ClipboardList, path: "/admtask", roles: ["company","admin"] },
//   { id: "admlegal", label: "Legal & Compliance", icon: Scale, path: "/admlegal", roles: ["company","admin"] },
//   { id: "admretuser", label: "Retailer Users", icon: UserCog, path: "/admretuser", roles: ["company","admin"] },
//   { id: "admanltc", label: "Analytics & Targets", icon: BarChart3, path: "/admanltc", roles: ["company","admin"] },

//   // EMPLOYEE DASHBOARD
//   { id: "empdash", label: "EMP Dashboard", icon: LayoutDashboard, path: "/empdashboard", roles: ["admin","company","employee","agent"] },

//   // OPERATION DASHBOARD
//   { id: "oprdash", label: "OPR Dashboard", icon: LayoutDashboard, path: "/oprdashboard", roles: ["employee"] },
//   { id: "oprret", label: "Retailers", icon: Store, path: "/oprretail", roles: ["employee"] },
//   { id: "oprtasks", label: "Tasks", icon: ClipboardCheck, path: "/oprtasks", roles: ["employee"] },
//   { id: "oprreports", label: "Reports", icon: FileText, path: "/oprreports", roles: ["employee"] },

//   // AGENT DASHBOARD
//   { id: "agentdashboard", label: "Agent Dashboard", icon: LayoutDashboard, path: "/agentdashboard", roles: ["agent"] },
//   { id: "agentretailers", label: "Retailers & Earnings", icon: Wallet, path: "/agentretailers", roles: ["agent"] },
//   { id: "agtcom", label: "Commission", icon: IndianRupee, path: "/agtcom", roles: ["agent"] },

//   // RETAILER DASHBOARD
//   { id: "retaileronboard", label: "Retailer Onboarding", icon: UserPlus, path: "/onboard", roles: [ "retailer"] },
//   { id: "retailerdashboard", label: "Retailer Dashboard", icon: LayoutDashboard, path: "/retailerdashboard", roles: ["retailer"] },
//   { id: "retwarnty", label: "Warranty", icon: ShieldCheck, path: "/retwarnty", roles: ["retailer"] },
//   { id: "retinv", label: "Invoices & Payment", icon: ReceiptIndianRupee, path: "/retinv", roles: ["retailer"] },
//   { id: "retledger", label: "Ledger", icon: FileText, path: "/retledger", roles: ["retailer"] },
//   { id: "retuser", label: "User & Access", icon: UserCog, path: "/retuser", roles: ["retailer"] },
//   { id: "retuserdoc", label: "Legal & KYC", icon: FileBadge, path: "/retuserdoc", roles: ["retailer"] },

//   // USER DASHBOARD
//   { id: "userdashboard", label: "User Dashboard", icon: LayoutDashboard, path: "/userdashboard", roles: ["retailer"] },
//   { id: "userwarnty", label: "Warranty", icon: ShieldCheck, path: "/userwarnty", roles: ["retailer"] },
//   { id: "userdoc", label: "Legal & Consents", icon: FileQuestion, path: "/userdoc", roles: ["retailer"] },
//   { id: "userprofile", label: "Profile", icon: Users, path: "/userprofile", roles: ["retailer"] },

//   // CUSTOMER DASHBOARD
//   { id: "custdashboard", label: "Cust Dashboard", icon: LayoutDashboard, path: "/custdashboard", roles: ["retailer", "customer"] },
//   { id: "custwarnty", label: "My Warranties", icon: ShieldCheck, path: "/custwarnty", roles: ["retailer", "customer"] },
//   { id: "custclaims", label: "Claims", icon: ClipboardList, path: "/custclaims", roles: ["retailer", "customer"] },
//   { id: "custdoc", label: "Legal & Policy", icon: FileQuestion, path: "/custdoc", roles: ["retailer", "customer"] },
//   { id: "custspt", label: "Support", icon: Headset, path: "/custspt", roles: ["retailer", "customer"] },
// ];

// export default navBarData;



// import { 
  //   LayoutDashboard, Users, UserPlus, Store, ShieldCheck, 
  //   ClipboardList, Scale, IndianRupee, BarChart3, 
  //   UserCog, FileText, ClipboardCheck, Headset, Wallet, 
  //   Building2, FileBadge, FileQuestion, ReceiptIndianRupee,
  // } from "lucide-react";

  // const navBarData = [

  //   // SUPER DASHBOARD
  //   { id: "superdashboard", label: "super Admin Dashboard", icon: LayoutDashboard, path: "/superdashboard" , role: "admin" },
  //   // { id: "categories", label: "categories", icon: LayoutDashboard, path: "/superdashboard" },
    
    

  //   // MAIN DASHBOARD
  //   { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard", role: "company" },
  //   // { id: "allemployees", label: "Employees", icon: Users, path: "/allemployees" },
  //   // { id: "add-employee", label: "Add Employee", icon: UserPlus, path: "/add-employee" },
  //   // { id: "allagents", label: "Agents", icon: Users, path: "/allagents" },
  //   // { id: "add-agent", label: "Add Agent", icon: UserPlus, path: "/add-agent" },
  //   // { id: "allretailers", label: "Retailers", icon: Store, path: "/allretailers" },
  //   // { id: "add-retailer", label: "Add Retailer", icon: Store, path: "/add-retailer" },

  //   // ADMIN DASHBOARD 
  //   // { id: "admindashboard", label: "Admin Dashboard", icon: LayoutDashboard, path: "/admindashboard" },

  //   { id: "admretailers", label: "Ops · Retailers", icon: Store, path: "/admretailers", role: "company" },
  //   { id: "admagents", label: "Agents & Onboarding", icon: Users, path: "/admagents", role: "company" },
  //   { id: "admwrnty", label: "Warranties & Claims", icon: ShieldCheck, path: "/admwrnty", role: "company" },
  //   { id: "admcomsn", label: "Commissions & Payouts", icon: IndianRupee, path: "/admcomsn", role: "company" },
  //   { id: "admtask", label: "Tasks & Work", icon: ClipboardList, path: "/admtask", role: "company" },
  //   { id: "admlegal", label: "Legal & Compliance", icon: Scale, path: "/admlegal", role: "company" },
  //   { id: "admretuser", label: "Retailer Users", icon: UserCog, path: "/admretuser", role: "company" },
  //   { id: "admanltc", label: "Analytics & Targets", icon: BarChart3, path: "/admanltc", role: "company" },

  //   // EMPLOYEE DASHBOARD
  //   { id: "empdash", label: "EMP Dashboard", icon: LayoutDashboard, path: "/empdashboard", role: "admin"  },

  //   // OPERATION DASHBOARD
  //   { id: "oprdash", label: "OPR Dashboard", icon: LayoutDashboard, path: "/oprdashboard", role: "employee" },
  //   { id: "oprret", label: "Retailers", icon: Store, path: "/oprretail", role: "employee"  },
  //   { id: "oprtasks", label: "Tasks", icon: ClipboardCheck, path: "/oprtasks", role: "employee" },
  //   { id: "oprreports", label: "Reports", icon: FileText, path: "/oprreports", role: "employee" },

  //   // AGENT DASHBOARD
  //   { id: "agentdashboard", label: "Agent Dashboard", icon: LayoutDashboard, path: "/agentdashboard", role: "agent" },
  //   { id: "agentretailers", label: "Retailers & Earnings", icon: Wallet, path: "/agentretailers", role: "agent" },
  //   { id: "agtcom", label: "Commission", icon: IndianRupee, path: "/agtcom", role: "agent" },

  //   // RETAILER DASHBOARD
  //   { id: "retaileronboard", label: "Retailer Onboarding", icon: UserPlus, path: "/onboard",role: "admin" },
  //   { id: "retailerdashboard", label: "Retailer Dashboard", icon: LayoutDashboard, path: "/retailerdashboard",role: "retailer" },
  //   { id: "retwarnty", label: "Warrenty", icon: ShieldCheck, path: "/retwarnty", role: "retailer"},
  //   { id: "retinv", label: "Invoices & Payment", icon: ReceiptIndianRupee, path: "/retinv", role: "retailer" },
  //   { id: "retledger", label: "Ledger", icon: FileText, path: "/retledger",role: "retailer" },
  //   { id: "retuser", label: "User & Access", icon: UserCog, path: "/retuser", role: "retailer" },
  //   { id: "retuserdoc", label: "Legal & KYC", icon: FileBadge, path: "/retuserdoc",role: "retailer" },

  //   // USER DASHBOARD
  //   { id: "userdashboad", label: "User Dashboard", icon: LayoutDashboard, path: "/userdashboard", role: "retailer" },
  //   { id: "userwarnty", label: "Warrenty", icon: ShieldCheck, path: "/userwarnty", role: "retailer" },
  //   { id: "userdoc", label: "Legal & Consents", icon: FileQuestion, path: "/userdoc", role: "retailer" },
  //   { id: "userprofile", label: "Profile", icon: Users, path: "/userprofile",role: "retailer" },

  //   // CUSTOMER DASHBOARD
  //   { id: "custdashboard", label: "Cust Dashboard", icon: LayoutDashboard, path: "/custdashboard",role: "retailer" },
  //   { id: "custwarnty", label: "My Warrenties", icon: ShieldCheck, path: "/custwarnty", role: "retailer" },
  //   { id: "custclaims", label: "Claims", icon: ClipboardList, path: "/custclaims", role: "retailer" },
  //   { id: "custdoc", label: "Legal & Policy", icon: FileQuestion, path: "/custdoc",role: "retailer" },
  //   { id: "custspt", label: "Support", icon: Headset, path: "/custspt", role: "retailer" },
  // ];

  // export default navBarData;


  // import { BarChart3, ClipboardList, IndianRupee, LayoutDashboard, Scale, ShieldCheck, Store, Users } from "lucide-react";

  // const navBarData = [
  //     // main Dashboard
  //   { id: "dashboard", label: "Dashboard", path: "/dashboard" },
  //   { id: "allemployees", label: "Employees", path: "/allemployees" },
  //   { id: "add-employee", label: "Add Employee", path: "/add-employee" },
  //   { id: "allagents", label: "Agents", path: "/allagents" },
  //   { id: "add-agent", label: "Add Agent", path: "/add-agent" },
  //   { id: "allretailers", label: "Retailers", path: "/allretailers" },
  //   { id: "add-retailer", label: "Add Retailer", path: "/add-retailer" },

  //   // Admin Dashboard 
  //   { id: "admindashboard", label: "Admin Dashboard", path: "/admindashboard" },
  //   { id: "admretailers", label: "Ops · Retailers", icon: Store, path:"/admretailers" },
  //   { id: "admagents", label: "Agents & Onboarding", icon: Users, path:"/admagents" },
  //   { id: "admwrnty", label: "Warranties & Claims", icon: ShieldCheck, path:"/admwrnty" },
  //   { id: "admcomsn", label: "Commissions & Payouts", icon: IndianRupee, path:"/admcomsn" },
  //   { id: "admtask", label: "Tasks & Work", icon: ClipboardList, path:"/admtask" },
  //   { id: "admlegal", label: "Legal & Compliance", icon: Scale, path:"/admlegal" },
  //   { id: "admretuser", label: "Retailer Users", icon: Users, path:"/admretuser" },
  //   { id: "admanltc", label: "Analytics & Targets", icon: BarChart3, path:"/admanltc" },
    
    
    
  // //   Employee Dashboard 
  //   { id: "empdash", label: "EMP Dashboard", path: "/empdashboard" },

  // //   Operation Dashboard
  //   { id: "oprdash", label: "OPR Dashboard", path: "/oprdashboard" },
  //   { id: "oprret", label: "Retailers", path:"/oprretail" },
  //   { id: "oprtasks", label: "Tasks", path:"/oprtasks" },
  //   { id: "oprreports", label: "Reports", path:"/oprreports" },

  // // Agent Dashboard
  //   { id: "agentdashboard", label: "Agent Dashboard", path: "/agentdashboard" },
  //   { id: "agentretailers", label: "Retailers & Earnings", path: "/agentretailers" },
  //   { id: "agtcom", label: "Commission", path: "/agtcom" },

  // //   Retailer Dashboard
  //   { id: "retaileronboard", label: "Retailer Onboarding", path: "/onboard" },
  //   { id: "retailerdashboard", label: "Retailer Dashboard", path: "/retailerdashboard" },
  //   { id: "retwarnty", label: "Warrenty", path: "/retwarnty" },
  //   { id: "retinv", label: "Invoices & Payment", path: "/retinv" },
  //   { id: "retledger", label: "Ledger", path: "/retledger" },
  //   { id: "retuser", label: "User & Access", path: "/retuser" },
  //   { id: "retuserdoc", label: "Legal & KYC", path: "/retuserdoc" },

  // //   User Dashboard
  //   { id: "userdashboad", label: "User Dashboard", path: "/userdashboard" },
  //   { id: "userwarnty", label: "Warrenty", path: "/userwarnty" },
  //   { id: "userdoc", label: "Legal & Consents", path: "/userdoc" },
  //   { id: "userprofile", label: "Profile", path: "/userprofile" },

  // //   Customer Dashboard 
  //     { id: "custdashboard", label: "Cust Dashboard", path: "/custdashboard" },
  //     { id: "custwarnty", label: "My Warrenties", path: "/custwarnty" },
  //     { id: "custclaims", label: "Claims", path: "/custclaims" },
  //     { id: "custdoc", label: "Legal & Policy", path: "/custdoc" },
  //     { id: "custspt", label: "Support", path: "/custspt" },
      
  // ];

  // export default navBarData;
